var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row no-gutters c514 p-2"},[_c('div',{staticClass:"col-md-3 col-3"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.image,"alt":_vm.alt}})]),_c('div',{staticClass:"col-md-9 col-9 pt-1 p-2"},[_vm._t("p-1")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }